export const artifactCopy = {
  preview: 'Visualizar arquivo',
  rendered: 'Prévia',
  source: 'Código original',
  fullscreen: 'Tela cheia',
  restore: 'Restaurar tamanho',
  newTab: 'Abrir em nova aba',
  download: 'Baixar arquivo',
  close: 'Fechar prévia',
  loading: 'Carregando prévia…',
  error: 'Não foi possível carregar a prévia. Você ainda pode baixar o arquivo.',
  retry: 'Tentar novamente',
  tooLarge: 'Este arquivo é grande demais para a prévia. Baixe para visualizar.',
  private: 'Arquivo da conversa · Privado na Workstation',
  markdown: 'Documento Markdown',
  html: 'Documento HTML',
}
